<template>
  <div class="play-container">
    <img
      :src="imgSrc"
      style="width: 100%"
    />
    <div style="padding: 30px 0; background: bisque">
      <h2>{{videoTitle}}</h2>
      <video
        class="full-height full-width mask-video"
        style="width: 100%"
        ref="video"
        :src="videoSrc"
        controls
        :poster="require('./../assets/poster.jpeg')"
        :autoplay="start"
        playsinline="true" webkit-playsinline="true"
        x-webkit-airplay="allow"
        preload="none"
      ></video>
    </div>
  </div>
</template>

<script>

export default {
  components: {},
  name: "HelloWorld",
  props: {
    msg: String,
    imgSrc: String,
    videoTitle: String,
    videoSrc: String
  },
  data() {
    return {
      start: false,
      downHintTxt: "我是党史讲述人",
      theme: "red",
      hls: "",
      init: true
      // styleObj: {
      //   background: 'url('+ require('./../assets/1_HCJS.jpg') +')',
      //   backgroundSize: '100%'
      // }
    };
  },
  mounted() {

  },
  methods: {
    handleImgClick() {
      console.log('clicked video')
      this.init = false;
    }
  },
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
.mask-video{
  /* -webkit-mask-box-image: url('./../assets/vignette-mask-small.png') 75 stretch; */
}
</style>
